import { LightOnIcon } from '@carboncopyco/icons';
import { ColorHex, MessageBox } from '@carboncopyco/ui';

type NotesInDesktopMessageProps = { onClose: () => void };

export const NotesInDesktopMessage = ({
  onClose,
}: NotesInDesktopMessageProps) => {
  return (
    <div className="pb-3">
      <MessageBox
        border
        info
        close
        handleClose={onClose}
        leftIcon={<LightOnIcon color={ColorHex.primary500} />}
        label="Notes are only visible when presenting with the desktop app."
      />
    </div>
  );
};
